
import WkField from './WkField';

import Mixin from './Mixin';

export default {
  // item
  name: 'WkFormItem',

  components: {
    WkField: WkField
  },

  mixins: [Mixin],

  props: {
    // 表单验证前缀
    propPrefix: {
      type: String,
      default: ''
    },
    item: Object,
    index: Number,
    fieldFrom: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 忽略的字段直接输出
    ignoreFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: Boolean
  },

  data: function data() {
    return {};
  },


  computed: {},

  watch: {},

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    fieldChange: function fieldChange(item, index, value, valueList) {
      this.$emit('change', item, index, value, valueList);
    }
  }
};